import { Col, FormGroup, FormText, Input, Row } from 'components/ui';
import { telegram_group_id } from 'lib/regex.js';
import { getInternetLinkParts } from 'lib/utils';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

const InternetLinkID = ({
	formData,
	update,
	updateVaccination,
	validation,
}) => {
	const [t] = useTranslation(['translation']);

	const updateLink = (data) => {
		const internet_link = data.internet_link || formData.internet_link;
		const case_id = data.case_id || formData.case_id;
		if (data.internet_link) {
			const { source_domain } = getInternetLinkParts(internet_link);

			if (source_domain && source_domain.indexOf('t.me') > -1) {
				const result = [...internet_link.matchAll(telegram_group_id)];
				if (result[0]?.groups?.id) {
					data.case_id = result[0]?.groups?.id;
				}
			}

			if (
				case_id &&
				updateVaccination &&
				source_domain == 'www.direktdemokratisch.jetzt' &&
				!formData?.vax_entry_vaccinations[0].vax_type_id
			) {
				const newVaccinations = [...formData.vax_entry_vaccinations];
				const newVaccination = { ...formData.vax_entry_vaccinations[0] };
				newVaccination.vax_type_id = '35';
				newVaccinations[0] = newVaccination;
				updateVaccination({
					// vaccinations: [formData.vax_entry_vaccination],
					vaccinations: newVaccinations,
					trigger: null,
					index: 0,
				});
			}
		}
		update(data);
	};

	return (
		<FormGroup className='mb-3' style={{ marginTop: '-18px' }}>
			<Row xs={12} style={{ marginTop: '20px' }}>
				<Col xs={12}>
					<FormText className='text-muted'>
						{t('impfschaeden.erfassen.option_aus_internet')}
					</FormText>
				</Col>
			</Row>
			<Row xs={12} style={{ marginTop: '5px' }}>
				<Col xs={12} md={12}>
					<Input
						fullWidth={true}
						type='text'
						label={t('impfschaeden.erfassen.internet_link')}
						value={formData.internet_link}
						onChange={(e) => updateLink({ internet_link: e.target.value })}
						isInvalid={validation['internet_link']}
						name='internet_link'
						id='internet_link_id'
					/>
				</Col>
			</Row>
			<Row xs={12} style={{ marginTop: '20px' }}>
				<Col xs={12}>
					<FormText className='text-muted'>
						{t('impfschaeden.erfassen.impfschaden_auf_internetseite_frage')}
					</FormText>
				</Col>
			</Row>
			<Row xs={12} style={{ marginTop: '5px' }}>
				<Col xs={12} md={6}>
					<Input
						type='text'
						label='ID'
						value={formData.case_id}
						onChange={(e) => updateLink({ case_id: e.target.value })}
						isInvalid={validation['case_id']}
						name='internet_link_caseId'
						id='internet_link_caseId_id'
					/>
				</Col>
			</Row>
		</FormGroup>
	);
};

InternetLinkID.propTypes = {
	formData: PropTypes.object,
	validation: PropTypes.object,
	update: PropTypes.func,
	updateVaccination: PropTypes.func,
};

export default InternetLinkID;
